module.exports = __webpack_public_path__ + "static/img/Section3.05f6510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Section3.png
// module id = Jr//
// module chunks = 1